module.exports = __webpack_public_path__ + "img/tanzania.327c30be.png";